export const es = {
  app: {
    title: 'StudyQuantifier',
    subtitle: 'Cuantificación del estudio y práctica deliberada'
  },
  common: {
    start: 'Iniciar',
    stop: 'Detener',
    pause: 'Pausar',
    resume: 'Reanudar',
    cancel: 'Cancelar',
    save: 'Guardar',
    discard: 'Descartar',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    expand: 'Expandir',
    collapse: 'Contraer',
    continue: 'Continuar',
    yes: 'Sí',
    no: 'No',
    loading: 'Cargando…',
    error: 'Error',
    retry: 'Reintentar',
    search: 'Buscar',
    filter: 'Filtrar',
    all: 'Todos',
    none: 'Ninguno'
  },
  themes: {
    label: 'Tema',
    dark: 'Oscuro',
    oled: 'OLED',
    light: 'Claro'
  },
  session: {
    modeA: 'Práctica deliberada',
    modeB: 'Repaso activo',
    start: 'Iniciar sesión',
    end: 'Finalizar sesión',
    duration: 'Duración',
    focus: 'Foco',
    break: 'Descanso',
    readingTime: 'Tiempo de lectura',
    distractions: 'Distracciones',
    frustration: 'Frustración',
    energy: 'Energía'
  },
  bootstrap: {
    greeting: 'Bootstrap Fase 1 operativo.',
    counter: 'Contador'
  },
  macroTimer: {
    title: 'Bloque de estudio',
    stateInactive: 'Listo para comenzar',
    stateFocusRunning: 'Foco en curso',
    stateFocusPaused: 'Foco en pausa',
    stateBreakRunning: 'Descanso en curso',
    stateBreakPaused: 'Descanso en pausa',
    statePendingFinish: 'Bloque finalizado',
    stateFinished: 'Bloque terminado',
    stateDiscarded: 'Bloque descartado',
    stateOpenEnded: 'Bloque abierto en curso',
    actionStart: 'Iniciar bloque',
    actionPause: 'Pausar',
    actionResume: 'Reanudar',
    actionFinish: 'Finalizar',
    actionConfirmFinish: 'Confirmar fin',
    actionResumeStudying: 'Seguir estudiando',
    actionDiscard: 'Descartar',
    actionNewSession: 'Nueva sesión',
    reading: 'Lectura',
    distractions: 'Distracciones',
    addDistraction: '+1 distracción',
    addReading: 'Añadir lectura',
    readingMinutesShort: '{n} min'
  },
  pomodoro: {
    statusIdle: 'En espera',
    statusFocusRunning: 'Enfoque activo',
    statusFocusPaused: 'Enfoque pausado',
    statusBreakRunning: 'Descanso activo',
    statusBreakPaused: 'Descanso pausado',
    statusPendingFinish: 'Listo para cerrar',
    statusFinished: 'Sesión completa',
    statusDiscarded: 'Sesión descartada',
    timeRemaining: '{min} min restantes',
    progressPct: '{pct}% completado',
    controlPause: 'Pausar',
    controlResume: 'Reanudar',
    controlFinish: 'Terminar bloque',
    controlReset: 'Reiniciar sesión',
    controlDistraction: '+1 distracción',
    controlReadingStart: 'Iniciar lectura',
    controlReadingPause: 'Pausar lectura',
    readingFooterLabel: 'Lectura',
    resetTitle: '¿Reiniciar la sesión?',
    resetIntro: 'Perderás {list}.',
    resetNothingToLose: 'Aún no hay nada que perder.',
    resetProblems: '{n} problema',
    resetProblemsPlural: '{n} problemas',
    resetFocus: '{min} min de enfoque',
    resetConjectures: '{n} conjetura',
    resetConjecturesPlural: '{n} conjeturas',
    resetConjunction: ' y ',
    resetHint: 'Esta acción no se puede deshacer.',
    resetCancel: 'Cancelar',
    resetConfirm: 'Reiniciar'
  },
  problemTimer: {
    problemNumber: 'Problema',
    hintIdle: 'Presiona ESPACIO para iniciar',
    hintRunning: 'Resolviendo en foco ciego…',
    hintEvaluating: 'Detenido',
    nextHint: 'N para siguiente · ESC para descartar',
    timePlaceholder: '—:—.—',
    blindModeOn: 'Modo ciego: activo',
    blindModeOff: 'Modo ciego: inactivo',
    conjectureHint: 'Se guarda con la cadena actual (materia → subtema → libro → capítulo → sección). Si hay un problema corriendo, se adjunta su número.',
    evaluatingLabel: 'Clasificando',
    readingLabel: 'Lectura',
    conjectureLabel: 'Conjetura',
    conjectureToggle: 'Añadir conjetura',
    conjectureShow: 'Mostrar campo de conjetura',
    conjectureHide: 'Ocultar campo de conjetura',
    conjecturePlaceholder: 'Captura una idea, pregunta o intuición…',
    conjectureSave: 'Guardar',
    conjectureSaveFull: 'Guardar conjetura',
    timesUp: 'Tiempo agotado'
  },
  shortcuts: {
    title: 'Atajos de teclado',
    intro: 'Todos los atajos funcionan cuando el foco no está en un campo de texto.',
    hint: 'Puedes personalizarlos desde Preferencias.',
    close: 'Cerrar',
    openLabel: 'Ver atajos de teclado (?)',
    problemToggle: 'Iniciar / detener problema',
    problemNext: 'Siguiente problema',
    problemDiscard: 'Descartar intento',
    rate1: 'Marcar como correcto',
    rate2: 'Marcar como incorrecto',
    rate3: 'Marcar como no resuelto',
    macroStart: 'Iniciar sesión',
    macroPause: 'Pausar sesión',
    macroResume: 'Reanudar sesión',
    macroFinish: 'Terminar sesión',
    none: '—'
  },
  recentProblems: {
    ariaLabel: 'Problemas recientes',
    fallbackTitle: 'Problemas recientes',
    empty: 'Tu primer problema aparecerá aquí. Presiona ESPACIO para empezar.',
    modePractice: 'Práctica',
    modeRecall: 'Repaso',
    colNumber: '#',
    colTime: 'Tiempo',
    colResult: 'Resultado',
    resultCorrect: 'Correcto',
    resultIncorrect: 'Incorrecto',
    resultUnresolved: 'No resuelto',
    groupOpen: 'Abrir sesión',
    groupClose: 'Cerrar sesión'
  },
  rating: {
    correct: 'Correcto',
    hint: 'Clasifica el intento con las teclas 1, 2 o 3 — o toca un botón.',
    shortcut1: 'tecla 1',
    shortcut2: 'tecla 2',
    shortcut3: 'tecla 3',
    incorrect: 'Incorrecto',
    unresolved: 'No resuelto',
    ariaLabel: 'Calificación del intento',
    notesLabel: 'Nota',
    notesPlaceholder: '¿Qué aprendiste de este intento?',
    taxonomyLabel: 'Causa raíz',
    taxonomyNone: 'Sin especificar',
    next: 'Siguiente problema',
    nextDisabled: 'Califica el intento para continuar',
    discard: 'Descartar',
    discardedToast: 'Problema descartado',
    discardedUndo: 'Deshacer',
    needRating: 'Califica el intento para continuar'
  },
  modeB: {
    title: 'Repaso activo',
    groupsTitle: 'Grupos de repaso',
    groupsEmpty: 'Sin repasos pendientes',
    groupsEmptyHint: 'No tienes items pendientes de repaso. Vuelve más tarde.',
    groupsCounter: '{groups} grupos · {items} ítems',
    groupSingular: 'grupo',
    groupPlural: 'grupos',
    itemSingular: 'ítem',
    itemPlural: 'ítems',
    groupsHint: 'Elige un grupo para empezar',
    backToGroups: 'Volver a grupos',
    groupItems: '{n} ítems',
    mostUrgent: 'Más urgente',
    pickGroup: 'Elige un grupo para empezar',
    contextLabel: 'Problema original',
    itemCounter: 'Ítem {current} de {total}',
    problemLabel: 'Problema',
    hintIdle: 'Presiona ESPACIO para iniciar',
    hintRunning: 'Resolviendo a ciegas…',
    hintEvaluating: 'Detenido',
    correct: 'Bien',
    incorrect: 'Mal',
    consulted: 'Consulté la solución',
    consultedHint: 'Marca esta casilla si tuviste que mirar la solución para responder.',
    ariaLabel: 'Calificación del repaso',
    exitConfirmTitle: '¿Salir del repaso?',
    exitConfirmBody: 'Si sales ahora, perderás el progreso del ítem actual sin guardar.',
    next: 'Siguiente',
    finish: 'Terminar repaso',
    finishGroup: 'Terminar grupo',
    exit: 'Salir',
    noDue: 'No hay problemas vencidos',
    needRating: 'Califica el ítem para continuar'
  },
  prepare: {
    title: 'Preparar sesión',
    subject: 'Materia',
    subtopic: 'Subtema',
    book: 'Libro',
    chapter: 'Capítulo',
    section: 'Sección',
    chooseSubject: 'Elige una materia',
    chooseSubtopic: 'Elige un subtema',
    chooseBook: 'Elige un libro',
    chooseChapter: 'Elige un capítulo',
    chooseSection: 'Elige una sección',
    addSubtopic: '+ Nuevo subtema',
    empty: 'Aún no tienes materias',
    emptyHint: 'Crea tu primera materia para comenzar a cuantificar tu estudio.',
    createFirst: 'Crear primera materia',
    addSubject: '+ Nueva materia',
    addBook: '+ Nuevo libro',
    addChapter: '+ Nuevo capítulo',
    addSection: '+ Nueva sección',
    nameLabel: 'Nombre',
    create: 'Crear',
    cancel: 'Cancelar',
    optional: 'opcional',
    startBlock: 'Iniciar bloque',
    yourSession: 'Tu sesión',
    needSubject: 'Elige una materia para comenzar',
    requiredLegend: '* Campo obligatorio',
    optionalLegend: 'Los demás campos son opcionales — el retention se hereda automáticamente.',
    reviewDue: 'Repasar',
    reviewDueCount: '{n} pendientes',
    duration: 'Duración del bloque',
    durationOpen: 'Abierto',
    durationManual: 'Manual',
    durationMinutes: '{n} min',
    durationOpenHint: 'Corre hasta que lo detengas'
  },
  summary: {
    title: '¡Buena sesión!',
    subtitle: 'Registra cómo te sentiste para afinar tu calendario.',
    frustrationHelp: 'Cuánto te costó mantener el foco en esta sesión.',
    energyHelp: 'Nivel de energía mental al cerrar la sesión.',
    focus: 'Tiempo de foco',
    reading: 'Tiempo de lectura',
    distractions: 'Distracciones',
    attemptsTitle: 'Intentos',
    correct: 'Correctos',
    incorrect: 'Incorrectos',
    unresolved: 'No resueltos',
    noAttempts: 'Sin intentos registrados',
    averageProblem: 'Promedio por problema',
    frustration: 'Frustración',
    energy: 'Energía',
    sliderHint: '0 = nada · 10 = extremo',
    save: 'Guardar sesión',
    saving: 'Guardando…',
    keepStudying: 'Seguir estudiando',
    discard: 'Descartar',
    confirmDiscard: 'Confirmar descarte',
    discardWarning: 'Esto eliminará permanentemente todos los intentos de esta sesión.',
    cancel: 'Cancelar'
  },
  locale: {
    label: 'Idioma',
    en: 'English',
    es: 'Español'
  },
  sync: {
    open: 'Sincronizar',
    guest: 'Inicia sesión para sincronizar',
    running: 'Sincronizando…',
    never: 'Aún no sincronizado',
    lastAt: 'Última sincronización: {when}',
    justNow: 'hace un momento',
    minutesAgo: 'hace {n} min',
    hoursAgo: 'hace {n} h',
    daysAgo: 'hace {n} d',
    error: 'Error de sync: {msg}',
    pending: '{n} pendientes',
    conflicts: '{n} conflictos'
  },
  quarantine: {
    title: 'Cuarentena',
    close: 'Cerrar',
    open: 'Abrir cuarentena',
    empty: 'No hay operaciones en cuarentena.',
    emptyHint: 'Las operaciones de sync fallidas aparecerán aquí para recuperación manual.',
    opsLabel: 'ops',
    retry: 'Reintentar',
    discard: 'Descartar',
    retryAll: 'Reintentar todas',
    discardAll: 'Descartar todas',
    flashRetriedOne: 'Operación encolada para sync.',
    flashDiscardedOne: 'Operación descartada.',
    flashRetriedMany: '{n} operaciones encoladas para sync.',
    flashDiscardedMany: '{n} operaciones descartadas.',
    bannerNew: '{n} operaciones en cuarentena. Revísalas.',
    bannerReview: 'Revisar'
  },
  orphan: {
    title: 'Sesión sin terminar',
    body: 'Hay una sesión activa de hace {when}. ¿La retomas o la descartas?',
    resume: 'Retomar',
    discard: 'Descartar',
    justNow: 'un momento',
    minutesAgo: '{n} min',
    hoursAgo: '{n} h',
    daysAgo: '{n} d'
  },
  crossTab: {
    followerBanner: 'Otra pestaña es la ventana principal. Las sesiones y la sincronización se gestionan allí.',
    followerBlockedStart: 'Inicia una sesión en la pestaña principal.',
    syncViaMaster: 'Sync solicitado desde la ventana principal',
    becomePrimary: 'Abre esta pestaña en primer plano',
    takeOver: 'Tomar control',
    takingOver: 'Tomando control…',
    masterBusy: 'La ventana principal tiene una sesión activa. Ciérrala primero.',
    nowMaster: 'Esta pestaña es ahora la principal.'
  },
  migration: {
    title: 'Migrar datos de invitado',
    intro: 'Encontramos datos creados mientras usabas la app como invitado. Puedes migrarlos a tu cuenta o descartarlos permanentemente.',
    statsTitle: 'Se migrará',
    subjects: '{n} materias',
    subtopics: '{n} subtemas',
    books: '{n} libros',
    chapters: '{n} capítulos',
    sections: '{n} secciones',
    sessions: '{n} sesiones',
    attempts: '{n} intentos',
    recalls: '{n} ítems de repaso',
    reviews: '{n} eventos de repaso',
    conjectures: '{n} conjeturas',
    sleep: '{n} registros de sueño',
    total: '{n} ítems totales',
    migrate: 'Migrar a mi cuenta',
    migrating: 'Migrando…',
    discard: 'Descartar datos de invitado',
    discardWarning: 'Esto eliminará permanentemente todos los datos de invitado. No se puede deshacer.',
    confirmDiscard: 'Sí, eliminar permanentemente',
    cancel: 'Cancelar',
    error: 'Migración falló: {msg}',
    done: 'Migración completada'
  },
  fsrsAdvanced: {
    title: 'Ajustes FSRS avanzados',
    close: 'Cerrar',
    loading: 'Cargando…',
    globalTitle: 'Valores globales',
    globalHint: 'Se aplican a cualquier materia sin override propio. Retención baja implica intervalos más largos.',
    retentionLabel: 'Retención objetivo',
    intervalLabel: 'Intervalo máximo',
    saveGlobal: 'Guardar global',
    saved: 'Ajustes globales guardados.',
    subjectsTitle: 'Materias',
    subjectsHint: 'El override por materia se edita desde el ícono de ajustes en Preparar sesión. Restablece aquí para volver al global.',
    noSubjects: 'Aún no hay materias.',
    noSubjectsHint: 'Crea una materia para configurar overrides FSRS por materia.',
    colName: 'Materia',
    colRetention: 'Retención',
    colInterval: 'Int. máx.',
    override: 'Override',
    inherited: 'Global',
    resetOverride: 'Restablecer override'
  },
  subjectSettings: {
    title: 'Ajustes de la materia',
    close: 'Cerrar',
    loading: 'Cargando…',
    retention: 'Retención objetivo',
    retentionHint: 'Probabilidad con la que quieres recordar un problema cuando toca repasarlo. Más alta implica intervalos más cortos.',
    save: 'Guardar',
    cancel: 'Cancelar',
    saved: 'Ajustes guardados.',
    deleteTitle: 'Eliminar nodo',
    deleteIntro: 'Se eliminará «{name}» y todos sus elementos dependientes.',
    deleteHint: 'Los problemas ya registrados se conservan. Podrás deshacer desde el toast.',
    confirmDelete: 'Eliminar',
    advanced: 'Avanzado',
    maximumInterval: 'Intervalo máximo',
    maximumIntervalHint: 'Tope máximo entre repasos. Bajo si estudias todos los días, alto si estudias semanalmente.',
    subtopics: 'Subtemas',
    overrideActive: 'Override',
    overrideInactive: 'Hereda',
    retentionShort: 'Retención',
    intervalShort: 'Int. máx.',
    daysSuffix: 'd',
    definedHere: 'Definido aquí',
    inheritedFrom: 'Heredado de {source}',
    resetOverride: 'Restaurar herencia',
    sourceSubject: 'la materia',
    sourceSubtopic: 'el subtema',
    sourceBook: 'el libro',
    sourceChapter: 'el capítulo',
    sourceSection: 'la sección',
    sourceGlobal: 'ajustes globales',
    sourceDefault: 'por defecto',
    childSubtopics: 'Subtemas',
    childBooks: 'Libros',
    childChapters: 'Capítulos',
    childSections: 'Secciones',
    noChildren: 'Sin hijos directos.'
  },
  avatar: {
    sectionTitle: 'Foto de perfil',
    sectionHint: 'Se muestra junto a tu nombre en el leaderboard. Máx 5 MB. Se redimensiona automáticamente.',
    upload: 'Elegir imagen',
    remove: 'Quitar',
    uploaded: 'Foto de perfil actualizada.',
    removed: 'Foto de perfil eliminada.',
    tooLarge: 'La imagen es demasiado grande (máx 5 MB).',
    invalidType: 'Solo PNG, JPG, WEBP o GIF.',
    failed: 'Falló la subida. Inténtalo de nuevo.',
    current: 'Foto actual'
  },
  push: {
    sectionTitle: 'Notificaciones',
    sectionHint: 'Recibe un recordatorio cuando tengas repasos pendientes. Requiere permiso del navegador.',
    toggle: 'Activar recordatorios',
    reminderHour: 'Hora del recordatorio',
    hourSuffix: ':00',
    unsupported: 'Este navegador no soporta notificaciones.',
    enabled: 'Recordatorios activados.',
    disabled: 'Recordatorios desactivados.',
    permissionDenied: 'Permiso denegado. Activa las notificaciones en los ajustes del navegador.',
    failed: 'No se pudieron activar los recordatorios. Inténtalo de nuevo.',
    saved: 'Hora del recordatorio actualizada.'
  },
  leaderboard: {
    open: 'Abrir leaderboard',
    panel: {
      title: 'Leaderboard',
      close: 'Cerrar',
      metricMinutes: 'Horas totales',
      metricProblems: 'Problemas hoy',
      metricStreak: 'Racha',
      tabGlobal: 'Global',
      tabCountry: 'País: {code}',
      tabFriends: 'Amigos',
      tabGroup: 'Grupo: {name}',
      metricTotalProblems: 'Total problemas',
      metricRetention: 'Retención',
      noGroups: 'Aún no tienes grupos.',
      friendsEmpty: 'Añade amigos para verlos aquí.',
      friendsEmptyHint: 'Estudia con otros y compara tu progreso.',
      groupEmpty: 'Sin entradas en este grupo todavía.',
      groupEmptyHint: 'Espera a que los miembros registren sesiones.',
      emptyHint: 'Sigue estudiando y aparecerás en el ranking.',
      colRank: '#',
      colUser: 'Usuario',
      colCountry: 'País',
      colProblemsToday: 'Hoy',
      colMinutesToday: 'Tiempo hoy',
      colStreak: 'Racha',
      colTotal: 'Total',
      colRetention: 'Retención',
      loadMore: 'Cargar más',
      loading: 'Cargando…',
      empty: 'Aún no hay entradas.',
      errorLoad: 'No se pudo cargar el leaderboard.',
      youLabel: 'Tú'
    },
    sectionTitle: 'Leaderboard',
    sectionHint: 'Comparte tus estadísticas agregadas con otros usuarios. Puedes desactivarlo cuando quieras.',
    optIn: 'Aparecer en el leaderboard',
    displayName: 'Nombre de usuario',
    displayNamePlaceholder: '3-24 caracteres',
    displayNameTaken: 'Ese nombre ya está en uso. Prueba otro.',
    nameTooShort: 'Mínimo 3 caracteres.',
    nameTooLong: 'Máximo 24 caracteres.',
    nameInvalidChars: 'Solo letras, números, espacios, guiones y guiones bajos.',
    nameReserved: 'Ese nombre está reservado.',
    nameOffensive: 'Ese nombre no está permitido.',
    country: 'País',
    countryPirate: 'Pirata',
    countryHint: 'Se muestra junto a tu nombre. Elige Pirata para ocultar tu país real.',
    optInRequiresName: 'Elige un nombre antes de activar.',
    saved: 'Ajustes del leaderboard guardados.',
    disabled: 'Leaderboard desactivado. Tu entrada fue eliminada.',
    nameCooldown: 'Podrás cambiar tu nombre de nuevo a partir del {date}.',
    nameCooldownShort: 'Cambio de nombre disponible a partir del {date}.',
    nameSaved: 'Nombre actualizado.'
  },
  groups: {
    title: 'Grupos',
    close: 'Cerrar',
    loading: 'Cargando…',
    create: 'Crear grupo',
    createTitle: 'Nuevo grupo',
    creating: 'Creando…',
    createError: 'No se pudo crear el grupo.',
    invalidName: 'El nombre debe tener entre 1 y 40 caracteres.',
    name: 'Nombre del grupo',
    namePlaceholder: 'p. ej. Física modo difícil',
    join: 'Unirse por código',
    joinTitle: 'Unirse a un grupo',
    joining: 'Uniéndose…',
    joinError: 'No se pudo unir al grupo.',
    invalidCode: 'Ese código no existe.',
    alreadyMember: 'Ya estás en ese grupo.',
    code: 'Código de invitación',
    codePlaceholder: 'ABCD1234',
    copyCode: 'Click para copiar',
    copied: '¡Copiado!',
    noGroups: 'Aún no estás en ningún grupo.',
    owner: 'Dueño',
    member: 'miembro',
    members: 'miembros',
    leave: 'Salir',
    delete: 'Eliminar',
    confirmLeave: '¿Salir?',
    confirmDelete: '¿Eliminar para todos?',
    confirmYes: 'Sí',
    cancel: 'Cancelar'
  },
  friends: {
    title: 'Amigos',
    close: 'Cerrar',
    loading: 'Cargando…',
    tabIncoming: 'Recibidas',
    tabOutgoing: 'Enviadas',
    tabFriends: 'Amigos',
    add: 'Añadir',
    addTitle: 'Añadir amigo',
    addHint: 'Busca por nombre exacto. Máximo 5 resultados.',
    searchPlaceholder: 'Nombre de usuario',
    search: 'Buscar',
    searching: 'Buscando…',
    noResults: 'No hay usuarios con ese nombre.',
    sendRequest: 'Enviar solicitud',
    sending: 'Enviando…',
    sentOk: 'Solicitud enviada.',
    sentAlready: 'Ya hay una solicitud pendiente.',
    sentError: 'No se pudo enviar la solicitud.',
    accept: 'Aceptar',
    decline: 'Rechazar',
    cancel: 'Cancelar',
    remove: 'Eliminar',
    noIncoming: 'No hay solicitudes recibidas.',
    noOutgoing: 'No hay solicitudes enviadas.',
    noFriends: 'Aún no tienes amigos.',
    unknown: 'Usuario desconocido'
  },
  foreignQueues: {
    title: 'Operaciones de otras cuentas',
    intro: 'Este dispositivo tiene operaciones pendientes de {n} cuenta(s). Nada se borra automáticamente.',
    empty: 'No hay operaciones de otras cuentas.',
    emptyHint: 'Las operaciones encoladas de otras cuentas aparecerán aquí.',
    close: 'Cerrar',
    opsLabel: 'ops',
    export: 'Exportar',
    move: 'Mover a esta cuenta',
    discard: 'Descartar',
    flashExported: 'Cola exportada.',
    flashMoved: '{n} operaciones movidas a esta cuenta.',
    flashDiscarded: '{n} operaciones descartadas.',
    confirmDiscardInline: '¿Descartar {n} ops ({bytes})? No se puede deshacer.',
    yesDiscard: 'Sí, descartar',
    no: 'No',
    moveTitle: 'Mover operaciones a esta cuenta',
    moveBody: 'Esto moverá {n} operaciones ({bytes}) a la cuenta actual. Si los mismos datos ya existen en el servidor, se crearán duplicados.',
    moveAck: 'Entiendo que pueden aparecer duplicados.',
    moveConfirm: 'Mover',
    cancel: 'Cancelar'
  },
  auth: {
    pendingQueue: {
      title: 'Operaciones pendientes',
      body: 'Esta cuenta tiene {n} operaciones pendientes de sincronizar ({bytes}). Se quedarán en este dispositivo tras cerrar sesión. Vuelve a entrar con la misma cuenta para subirlas, o expórtalas ahora.',
      cancel: 'Cancelar',
      leave: 'Cerrar sesión, dejarlas aquí',
      export: 'Exportar y cerrar sesión'
    },
    title: 'Cuenta',
    signedInAs: 'Sesión iniciada como',
    signIn: 'Iniciar sesión',
    signUp: 'Crear cuenta',
    signOut: 'Cerrar sesión',
    email: 'Correo',
    password: 'Contraseña',
    passwordHint: 'Mínimo 6 caracteres',
    submitSignIn: 'Iniciar sesión',
    submitSignUp: 'Crear cuenta',
    switchToSignUp: '¿Sin cuenta? Crea una',
    switchToSignIn: '¿Ya tienes cuenta? Inicia sesión',
    busy: 'Procesando…',
    errorInvalidCredentials: 'Correo o contraseña incorrectos.',
    errorEmailInUse: 'Ese correo ya está registrado.',
    errorWeakPassword: 'La contraseña es demasiado corta.',
    errorGeneric: 'Algo salió mal. Inténtalo de nuevo.',
    guestBanner: 'Estás usando la app como invitado. Inicia sesión para sincronizar entre dispositivos.',
    open: 'Cuenta'
  },
  shell: {
    skipToContent: 'Saltar al contenido',
    brand: 'StudyQuantifier',
    nav: {
      studySection: 'Estudio',
      session: 'Sesión',
      history: 'Historial',
      progressSection: 'Progreso',
      analytics: 'Analítica',
      forecast: 'Forecast',
      checklist: 'Temario',
      communitySection: 'Comunidad',
      leaderboard: 'Leaderboard',
      friends: 'Amigos',
      groups: 'Grupos',
      personalSection: 'Personal',
      goals: 'Metas',
      conjectures: 'Conjeturas',
      sleep: 'Sueño',
      systemSection: 'Sistema',
      ariaSidebar: 'Navegación principal',
      ariaBottomNav: 'Navegación principal',
      preferences: 'Preferencias',
      quarantine: 'Cuarentena',
    },
    metrics: {
      today: 'Hoy',
      streak: 'Racha',
      dueToday: 'Repasos',
    },
    user: {
      authenticated: 'Cuenta',
      guest: 'Invitado · Iniciar sesión',
    },
    mobile: {
      openMenu: 'Abrir menú',
      closeMenu: 'Cerrar menú',
      more: 'Más',
    },
    sync: {
      idle: 'Sincronizado',
      syncing: 'Sincronizando…',
      pending: 'Pendiente',
      error: 'Error de sync',
    },
    follower: {
      banner: 'Esta pestaña está en modo espectador',
      takeover: 'Retomar control',
      takingOver: 'Retomando…',
      masterBusy: 'El master tiene una sesión activa',
    },
    offline: {
      banner: 'Sin conexión. Los cambios se sincronizarán al reconectar.',
    },
    migration: {
      banner: 'Tienes datos locales pendientes de migrar.',
      action: 'Migrar ahora',
    },
  },
  settings: {

    title: 'Preferencias',
    theme: 'Tema',
    themeDark: 'Oscuro',
    themeOled: 'OLED',
    themeTeal: 'Teal',
    themeSand: 'Arena',
    themeLight: 'Claro',
    themeSage: 'Sage',
    themeWine: 'Wine',
    themeCoral: 'Coral',
    languageHint: 'Selecciona el idioma de la aplicación.',
    customizeTheme: 'Personaliza la paleta de colores de la interfaz.',
    changeTheme: 'Cambiar Tema',
    showFrustration: 'Mostrar nivel de frustración',
    showEnergy: 'Mostrar nivel de energía',
    showReadingTime: 'Mostrar tiempo de lectura',
    showDistractions: 'Mostrar distracciones',
    alarmEnabled: 'Activar sonido de alarma del temporizador',
    keepScreenAwake: 'Mantener pantalla encendida durante sesiones',
    problemTimerMode: 'Modo del temporizador de problemas',
    problemTimerTimer: 'Cronómetro (sube)',
    problemTimerCountdown: 'Temporizador (baja)',
    countdownDuration: 'Duración',
    language: 'Idioma',
    shortcuts: 'Atajos de teclado',
    shortcutsHint: 'Haz clic en un campo y presiona una tecla. Escape cancela.',
    resetShortcuts: 'Restaurar por defecto',
    save: 'Guardar cambios',
    cancel: 'Cancelar',
    discard: 'Descartar cambios',
    unsavedWarning: 'Tienes cambios sin guardar. ¿Descartarlos?',
    confirmDiscard: 'Sí, descartar',
    dangerZone: 'Zona de peligro',
    clearAllDataConfirm: '¿Borrar TODOS tus datos? Esto incluye materias, sesiones, intentos, repasos, conjeturas y ajustes. Tu cuenta seguirá activa.',
    clearAllDataSuccess: 'Datos borrados. Tu cuenta sigue activa.',
    clearAllDataPartial: 'Datos locales borrados, pero {n} tablas remotas fallaron. Revisa tu conexión.',
    dangerHint: 'Acciones irreversibles. Procede con cuidado.',
    dangerPurgeLabel: 'Borrar todos los datos locales',
    dangerPurgeDescription: 'Elimina todas las materias, sesiones, intentos, ítems de repaso y preferencias guardadas en este dispositivo. No se puede deshacer.',
    dangerKeywordInstruction: 'Escribe {keyword} para confirmar.',
    dangerKeywordPlaceholder: 'Escribe aquí…',
    dangerPurge: 'Borrar todo',
    dangerKeywordMismatch: 'La palabra clave no coincide.',
    backup: 'Copia de seguridad',
    backupHint: 'Exporta tus datos como archivo JSON comprimido, o restaura desde una copia anterior.',
    export: 'Exportar datos',
    exporting: 'Exportando…',
    exportDone: 'Exportado {name} ({size})',
    import: 'Importar datos',
    importConfirm: 'Esto reemplazará todos tus datos locales. ¿Continuar?',
    importDone: 'Importados {count} registros',
    importCancel: 'Cancelar',
    importYes: 'Sí, reemplazar',
    importErrorInvalid: 'El archivo no es una copia de seguridad válida.',
    importErrorVersion: 'La copia usa una versión no soportada.',
    importErrorApp: 'El archivo no es una copia de StudyQuantifier.',
    importErrorDecompress: 'No se pudo leer el archivo.'
  },
  forecast: {
    title: 'Pronóstico',
    subtitle: 'Próximos 30 días de repasos',
    open: 'Pronóstico',
    dueToday: 'Vencidas hoy',
    active: 'Ítems activos',
    avgStability: 'Estabilidad media',
    avgDifficulty: 'Dificultad media',
    empty: 'Aún no hay repasos activos',
    emptyHint: 'Los ítems programados aparecerán aquí.',
    selectHint: 'Toca un día para ver sus ítems.',
    selectedDay: 'Día seleccionado',
    noItems: 'Sin ítems programados para este día',
    reviewNow: 'Repasar ahora',
    reviewAllDue: 'Repasar todas las vencidas hoy',
    back: 'Volver',
    today: 'Hoy',
    itemLabel: 'Problema {n}',
    close: 'Cerrar',
    dayAria: '{date}, {count} repasos'
  },
  manage: {
    deleteSubject: 'Eliminar materia',
    archiveTitle: 'Archivar materia',
    archiveIntro: 'La materia y todo su contenido serán archivados.',
    archiveHint: 'Las sesiones e intentos permanecen en tu historial. Puedes restaurarla después.',
    confirmArchive: 'Archivar',
    cancel: 'Cancelar',
    viewArchived: 'Archivadas ({n})',
    archivedTitle: 'Materias archivadas',
    archivedEmpty: 'Sin materias archivadas',
    archivedEmptyHint: 'Las materias que archives aparecerán aquí para restaurarlas.',
    archivedHint: 'Restaura una materia archivada para volver a usarla.',
    restore: 'Restaurar',
    countsHeader: 'Se archivará',
    preservedHeader: 'Preservado en el historial',
    subjects: 'Materias',
    subtopics: 'Subtemas',
    books: 'Libros',
    chapters: 'Capítulos',
    sections: 'Secciones',
    recallItems: 'Ítems de repaso',
    sessions: 'Sesiones',
    attempts: 'Intentos'
  },
  lifetime: {
    title: 'Total histórico',
    sessions: 'sesiones',
    activeDays: 'días activos'
  },
  analytics: {
    title: 'Analítica',
    subtitle: 'Tu progreso científico, en números y curvas.',
    open: 'Analítica',
    empty: 'Aún no hay suficientes datos',
    emptyHint: 'Crea intentos y repasos para ver gráficos aquí.',
    registered: 'Registrado el {date}',
    hoursZero: '—',
    howComputed: '¿Cómo se calcula?',
    backlog: {
      title: 'Backlog de repasos FSRS',
      dueNow: 'Vencidos hoy',
      next7d: 'Próximos 7 días',
      active: 'Ítems activos',
      empty: 'Sin repasos programados todavía. Los problemas mal o no resueltos se programan automáticamente.',
      cta: 'Ir a repasar'
    },
    summary: {
      totalItems: 'Ítems totales',
      activeItems: 'Activos',
      avgStability: 'Estabilidad media',
      medianStability: 'Estabilidad mediana',
      avgDifficulty: 'Dificultad media',
      dueToday: 'Vencidas hoy',
      totalReviews: 'Repasos'
    },
    scatter: {
      title: 'Estabilidad vs dificultad',
      xAxis: 'Dificultad',
      yAxis: 'Estabilidad'
    },
    curves: {
      title: 'Cómo decae tu memoria',
      xAxis: 'Días',
      yAxis: 'Retención',
      hint: 'Cada línea es una tarjeta con distinta estabilidad (en días). Cuanto más arriba se mantiene, más tiempo recuerdas sin repasar.'
    },
    heatmap: {
      title: 'Actividad del último año',
      legendLess: 'Menos',
      legendMore: 'Más',
      minutes: '{n} min',
      dayDetail: '{date} · {min} min',
      recentStartBanner: 'Empiezas a construir tu historial — sólo {days} días con actividad en el último año.',
      learnMore: 'Cómo contamos la actividad',
      legendTooltip0: 'Sin actividad',
      legendTooltip1: 'Actividad ligera (≤25% del máximo)',
      legendTooltip2: 'Actividad media (≤50%)',
      legendTooltip3: 'Actividad alta (≤75%)',
      legendTooltip4: 'Actividad máxima (100%)'
    },
    kpi: {
      sessionsStudied: 'Sesiones estudiadas',
      problemsAttempted: 'Problemas intentados',
      timeStudied: 'Tiempo estudiado',
      correct: 'Correctos',
      incorrect: 'Incorrectos',
      unresolved: 'No resueltos',
      pendingReviews: 'Repasos pendientes',
      conjectures: 'Conjeturas',
      hoursToday: 'Horas hoy',
      sessionsTip: 'Sesiones finalizadas con el timer del bloque.',
      problemsTip: 'Intentos de problema registrados en cualquier sesión.',
      timeStudiedTip: 'Suma del tiempo de enfoque de todas las sesiones terminadas.',
      correctTip: 'Intentos marcados como correctos.',
      incorrectTip: 'Intentos marcados como incorrectos — programados para repaso FSRS.',
      unresolvedTip: 'Intentos sin resolver — programados para repaso FSRS.',
      pendingReviewsTip: 'Ítems de repaso FSRS que ya vencieron y esperan revisión.',
      conjecturesTip: 'Notas e intuiciones guardadas.',
      hoursTodayTip: 'Tiempo de enfoque acumulado hoy.',
      dailyAvg: 'Promedio diario',
      dailyAvgTip: 'Promedio por día con actividad. Excluye días sin sesiones.',
      daysLearned: 'Días con actividad',
      daysLearnedOf: '{n} días · {pct}%',
      activeTotalLabel: '{n} ítems activos en total',
      longestStreak: 'Racha más larga',
      currentStreak: 'Racha actual',
      days: 'días',
      day: 'día',
      recalled: 'Repasado',
      streak: 'Racha',
      sinceLastSession: 'desde la última sesión'
    },
    breakdown: {
      todayTitle: 'Desglose de hoy',
      globalTitle: 'Desglose global',
      total: 'Total',
      activity30d: 'Actividad (últimos 30 días)'
    },
    chart: {
      axes: {
        x: 'Días desde el repaso',
        y: 'Probabilidad de recordar'
      },
      ariaLabel: 'Gráfico de curvas de olvido: cómo decae la probabilidad de recordar con el tiempo según la estabilidad de cada tarjeta.',
      legend: 'Estabilidad (días)'
    }
  },
  history: {
    title: 'Historial',
    open: 'Historial',
    noSessions: 'Aún no hay sesiones',
    noSessionsHint: 'Los bloques finalizados aparecen aquí.',
    loadMore: 'Cargar más',
    loading: 'Cargando…',
    session: 'Sesión',
    attempts: 'Intentos',
    duration: 'Foco',
    reading: 'Lectura',
    distractions: 'Distracciones',
    frustration: 'Frustración',
    energy: 'Energía',
    status: 'Estado',
    statusFinished: 'Finalizada',
    statusRunning: 'En curso',
    statusDiscarded: 'Descartada',
    statusPending: 'Pendiente',
    problem: 'Problema',
    result: 'Resultado',
    resultCorrect: 'Correcto',
    resultIncorrect: 'Incorrecto',
    resultUnresolved: 'No resuelto',
    taxonomy: 'Causa raíz',
    notes: 'Notas',
    edit: 'Editar',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    confirmDelete: '¿Eliminar este registro?',
    yes: 'Sí',
    no: 'No',
    minutes: '{n} min',
    noAttempts: 'Sin intentos registrados en esta sesión',
    attemptsCount: '{n} intentos'
  },
  conjectures: {
    title: 'Conjeturas',
    open: 'Conjeturas',
    newConjecture: 'Nueva conjetura',
    contentLabel: 'Intuición o hipótesis',
    contentPlaceholder: 'Escribe la intuición o idea teórica que quieras recordar…',
    subject: 'Materia',
    subjectNone: 'Sin materia',
    subtopic: 'Subtema',
    subtopicNone: 'Sin subtema',
    problemNumber: 'Número de problema',
    problemNumberPlaceholder: 'ej. 3.7',
    save: 'Guardar',
    saving: 'Guardando…',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    empty: 'Aún no hay conjeturas',
    emptyHint: 'Captura intuiciones teóricas mientras estudias. Aparecerán aquí.',
    list: 'Todas las conjeturas',
    filterBySubject: 'Filtrar por materia',
    allSubjects: 'Todas las materias',
    itemsCount: '{n} ítems',
    noResults: 'Ninguna conjetura coincide con el filtro'
  },
  checklist: {
    title: 'Temario',
    open: 'Temario',
    empty: 'Aún no tienes materias',
    emptyHint: 'Crea una materia para construir tu temario.',
    overall: 'Global',
    completedOf: '{done} / {total}',
    toggleComplete: 'Marcar como completado',
    expandAll: 'Expandir todo',
    collapseAll: 'Contraer todo',
    clearCompleted: 'Reiniciar todo',
    itemSubject: 'Materia',
    itemSubtopic: 'Subtema',
    itemBook: 'Libro',
    itemChapter: 'Capítulo',
    itemSection: 'Sección',
    addSyllabus: 'Añadir Temario',
    tabManual: 'Manual',
    tabImport: 'Importar con IA',
    rootNamePlaceholder: 'Nombre del Curso (ej. Matemáticas)',
    nodeNamePlaceholder: 'Nombre del Nodo',
    typePlaceholder: 'Tipo (ej. Curso)',
    subItemTypePlaceholder: 'Tipo (ej. Módulo)',
    addSubItem: 'Añadir Sub-elemento',
    cancel: 'Cancelar',
    create: 'Crear',
    rootNameError: 'Por favor, introduce un nombre para el nodo raíz antes de crear.',
    trashWarning: 'Restaurar un elemento también restaurará todos sus sub-elementos. Eliminarlo permanentemente también eliminará todos sus sub-elementos.',
    restore: 'Restaurar',
    deletePerm: 'Eliminar Permanentemente',
    deleteConfirm: '¿Estás seguro? Esto eliminará permanentemente este elemento y todos sus sub-elementos de la nube. Esta acción no se puede deshacer.'
  },
  goals: {
    title: 'Metas y racha',
    open: 'Metas',
    streak: 'Racha',
    streakDays: '{n} días',
    dayShort: '{n} d',
    longest: 'Más larga',
    todayProgress: 'Hoy',
    weekProgress: 'Esta semana',
    minutesOf: '{done} / {target} min',
    dailyTarget: 'Meta diaria (min)',
    weeklyTarget: 'Meta semanal (min)',
    activeDays: 'Días activos',
    save: 'Guardar',
    saving: 'Guardando…',
    saved: 'Guardado',
    last14Days: 'Últimos 14 días',
    noSessions: 'Sin sesiones finalizadas todavía',
    inGrace: 'Día de gracia — sigue así',
    streakBroken: 'Sin racha todavía',
    weekdays: {
      sun: 'Dom',
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mié',
      thu: 'Jue',
      fri: 'Vie',
      sat: 'Sáb'
    }
  },
  sleep: {
    title: 'Registro de sueño',
    open: 'Sueño',
    bedtime: 'Hora de acostarse',
    wakeTime: 'Hora de despertar',
    quality: 'Calidad',
    qualityLow: 'Mala',
    qualityHigh: 'Excelente',
    duration: 'Duración',
    hoursShort: '{h}h {m}m',
    save: 'Guardar',
    saving: 'Guardando…',
    update: 'Actualizar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    noRecords: 'Sin registros de sueño todavía',
    noRecordsHint: 'Registra tu sueño para rastrear calidad y patrones.',
    recentRecords: 'Registros recientes',
    circadianHint: 'Las horas de acostarse antes de las 18:00 se agrupan con el día anterior.',
    errorInvalidOrder: 'La hora de despertar debe ser posterior a la de acostarse.',
    errorTooShort: 'La duración debe ser de al menos 30 minutos.',
    errorTooLong: 'La duración no puede superar las 24 horas.',
    durationLabel: '{h} h {m} min',
    qualityLabel: 'C{q}'
  },
  errors: {
    generic: 'Ha ocurrido un error inesperado.',
    notFound: 'Recurso no encontrado.',
    network: 'Sin conexión. Los cambios se guardarán localmente.',
    storageFull: 'Almacenamiento local lleno.',
    unknown: 'Error desconocido.'
  }
} as const;